export type SnBrandLogoType = 'icon' | 'horizontal' | 'vertical';
